module.exports = __webpack_public_path__ + "static/media/princeton.07465213.png";